import { render } from "./AboutCardComponent.vue?vue&type=template&id=5d8313a3&scoped=true"
const script = {}

import "./AboutCardComponent.vue?vue&type=style&index=0&id=5d8313a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8313a3"]])

export default __exports__